// Library Imports
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  Table,
  TableBody,
  TableHeader,
  TableRow,
  TableHeaderColumn,
  TableSortableHeaderColumn,
} from '@unite-us/app-components';
import FeatureFlagContainer from 'src/common/utils/FeatureFlags/FeatureFlagContainer';
import { useFeatureFlag } from 'common/hooks';

// Util Imports
import { tableWidth } from 'common/helpers/Tables';

// Component Imports
import EmptyCase from './EmptyCase';
import CaseTableRow from './CaseTableRow';

const CasesTable = (props) => {
  const {
    cases,
    groupId,
    isCaseManager,
    condensedView = false,
    sortBy,
    sortDirection,
    onSortChange,
  } = props;

  if (_.isEmpty(cases)) {
    return <EmptyCase />;
  }

  const setSort = ({ sortBy: sort, sortDirection: direction }) => {
    onSortChange(sort, direction);
  };

  const displayCases = condensedView ? cases.slice(0, 2) : cases;
  const crtb2182ClarifyReferralLanguage = useFeatureFlag('crtb-2182-clarify-referral-language');

  const dashboardHeadersWithSortingEnabled = (
    <TableHeader>
      <TableRow>
        {crtb2182ClarifyReferralLanguage && <TableHeaderColumn style={{ width: tableWidth('icon') }} />}
        <TableHeaderColumn style={{ width: tableWidth('small') }}>
          Service Type
        </TableHeaderColumn>
        <TableSortableHeaderColumn
          style={{ width: tableWidth('small') }}
          colName={'opened_date'}
          sortBy={sortBy}
          sortDirection={sortDirection}
          setSort={setSort}
        >
          Date Opened
        </TableSortableHeaderColumn>
        <TableHeaderColumn style={{ width: tableWidth('small') }}>
          Status
        </TableHeaderColumn>
        <TableHeaderColumn style={{ width: tableWidth('medium') }}>
          Managing Organization
        </TableHeaderColumn>
        <TableSortableHeaderColumn
          style={{ width: tableWidth('small') }}
          colName={'updated_at'}
          sortBy={sortBy}
          sortDirection={sortDirection}
          setSort={setSort}
        >
          Last Updated
        </TableSortableHeaderColumn>
      </TableRow>
    </TableHeader>
  );
  return (
    <Table noBorder id="casesTable">
      {dashboardHeadersWithSortingEnabled}
      <TableBody>
        {displayCases.map((serviceCase, index) => {
          const serviceType = serviceCase.service;
          const primaryWorker = serviceCase.primary_worker;
          const serviceCaseGroup = serviceCase.provider;
          const isPendingAuth = isCaseManager && serviceCase?.state === 'pending_authorization';

          return (
            <CaseTableRow
              serviceCase={serviceCase}
              serviceType={serviceType}
              primaryWorker={primaryWorker}
              serviceCaseGroup={serviceCaseGroup}
              groupId={groupId}
              isCaseManager={isCaseManager}
              index={index}
              key={index}
              isPendingAuth={isPendingAuth}
            />
          );
        })}
      </TableBody>
    </Table>
  );
};

CasesTable.propTypes = {
  cases: PropTypes.array,
  condensedView: PropTypes.bool.isRequired,
  groupId: PropTypes.string.isRequired,
  isCaseManager: PropTypes.bool.isRequired,
  sortBy: PropTypes.string.isRequired,
  sortDirection: PropTypes.string.isRequired,
  onSortChange: PropTypes.func,
};

export default FeatureFlagContainer(CasesTable);
